import React, { useEffect, useState } from 'react';
import { ReactComponent as GeneralSurgeIcon } from 'assets/icons/overview/general-surge-icon.svg';
import { ReactComponent as PolygonSurgeIcon } from 'assets/icons/overview/polygon-surge-icon.svg';
import { ReactComponent as TopRidersIcon } from 'assets/icons/overview/top-riders-icon.svg';
import { ReactComponent as ExternalRiderIcon } from 'assets/icons/overview/external-rider-icon.svg';
import OverviewTopStatistics from './top-statistics';
import TopRidersModal from './top-riders-modal';
import { ActiveGeneralSurgeType } from 'models/surge.model';
import OverviewCard, { OverviewCardType } from 'components/logistics/overview-card';
import GeneralSurgeModal from 'components/logistics/surge/general';
import PolygonSurgeModal from 'components/logistics/surge/polygon';
import AvgDeliveryTimeChart from 'components/logistics/avg-delivery-time-chart';
import OrderChart from 'components/logistics/order-chart';
import useDashboardContext from 'contexts/dashboard.context';
import { useNavigate } from 'react-router-dom';
import { getGeneralSurgeSnapshot } from 'utils/firebase';
import useRoleContext from 'contexts/role.context';
import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';

const Overview = () => {
  const navigate = useNavigate();

  const [generalSurgeModal, setGeneralSurgeModal] = useState(false);
  const [polygonSurgeModal, setPolygonSurgeModal] = useState(false);
  const [topRidersModal, setTopRidersModal] = useState(false);
  const [generalSurge, setGeneralSurge] = useState<ActiveGeneralSurgeType>({
    id: '',
    logistics_surge: '',
    logistics_surge_type: ''
  });
  const [polygonSurge, setPolygonSurge] = useState<ActiveGeneralSurgeType>({
    id: '',
    logistics_surge: '',
    logistics_surge_type: ''
  });
  const { riderCount } = useDashboardContext();
  const { activeCokitchen } = useDashboardContext();
  const { role } = useRoleContext();

  const isNotSuperAdmin = role !== ENUM_ROLE.LOGISTICS_SUPER_ADMIN;

  const modalCards: OverviewCardType[] = [
    {
      icon: <GeneralSurgeIcon />,
      title: 'General Surge',
      desc: 'Add surge, schedule surge, edit scheduled surge and view surge history for all polygons',
      ctaText: 'Manage surge',
      ctaFn: () => setGeneralSurgeModal(true),
      currentValue: `${generalSurge.logistics_surge_type} - ${generalSurge.logistics_surge}x`
    },
    {
      icon: <PolygonSurgeIcon />,
      title: 'Polygon Surge',
      desc: 'Add surge, schedule surge, edit scheduled surge and view surge history for each polygons',
      ctaText: 'Manage surge',
      ctaFn: () => setPolygonSurgeModal(true),
      currentValue: `${polygonSurge.logistics_surge_type} - ${polygonSurge.logistics_surge}x`
    },
    {
      icon: <TopRidersIcon />,
      title: 'Top Riders',
      desc: 'Keep a tab on the best performing riders and see lorem ipsum later',
      ctaText: 'View top riders',
      ctaFn: () => setTopRidersModal(true)
    },
    {
      icon: <ExternalRiderIcon />,
      title: 'External Riders',
      desc: 'Monitor and manage external riders applications in real-time with ease',
      ctaText: 'View external riders',
      ctaFn: () => navigate('/external-riders'),
      count: riderCount.count,
      hide: isNotSuperAdmin
    }
  ];

  useEffect(() => {
    if (!activeCokitchen?.cokitchen_polygons) return;
    getGeneralSurgeSnapshot(activeCokitchen?.id, (doc: ActiveGeneralSurgeType) =>
      setGeneralSurge(doc)
    );
  }, [activeCokitchen]);

  return (
    <div>
      <OverviewTopStatistics />
      <p className=' font-medium py-3'>Quick Actions</p>
      <section className='grid grid-cols-3 lg:grid-cols-4 gap-6'>
        {modalCards.map((card, index) => (
          <OverviewCard key={index} {...card} />
        ))}
        {generalSurgeModal && (
          <GeneralSurgeModal
            show={generalSurgeModal}
            onClose={() => setGeneralSurgeModal(false)}
            activeSurge={generalSurge}
          />
        )}
        {polygonSurgeModal && (
          <PolygonSurgeModal
            show={polygonSurgeModal}
            onClose={() => setPolygonSurgeModal(false)}
            activeSurge={polygonSurge}
            setActiveSurge={setPolygonSurge}
          />
        )}
        <TopRidersModal show={topRidersModal} onClose={() => setTopRidersModal(!topRidersModal)} />
      </section>
      <div className='flex gap-10 justify-between w-full flex-col mt-8'>
        <AvgDeliveryTimeChart />
        <OrderChart />
      </div>
    </div>
  );
};

export default Overview;
